import Styled, { css } from 'styled-components';

import { media } from '../../../lib/StyledComponents/StyledComponents';
import { cssDeclaration } from '../Utils';

interface IStyledFooterProps {
  stackMobile?: boolean;
}

export const StyledFooter = Styled.footer<IStyledFooterProps>`
  width: 100%;
  display: flex;
  margin: 0 auto;
  position: relative;
  bottom: 0;

  ${({ theme: { themeTwo }, stackMobile }) => {
    const { layout: { footer }} = themeTwo;

    return css`
      /* font-family */ ${footer.font.family};
      /* color */ ${cssDeclaration(themeTwo, 'color', footer.font.color)};
      /* weight */ ${cssDeclaration(themeTwo, 'font-weight', footer.font.weight)};
      /* size */ ${cssDeclaration(themeTwo, 'font-size', footer.font.size)};

      /* background-color */ ${cssDeclaration(themeTwo, 'background-color', footer.backgroundColor)};
      /* padding */ ${cssDeclaration(themeTwo, 'padding', footer.padding)};
      /* height */ ${cssDeclaration(themeTwo, 'height', footer.height)};
      /* border */ ${cssDeclaration(themeTwo, 'border', footer.border)};
      /* width */ ${cssDeclaration(themeTwo, 'width', footer.width)};

      ${stackMobile && css`
        flex-direction: column;

        ${media.smallMedium`
          flex-direction: row;
        `}
      `}
    `;
  }}
`;
